import axios from "axios";
import axiosRetry from "axios-retry";
const instance = axios.create();

const fetchClientVersion = async () => {
  try {
    const response = await fetch("/version.json");
    const data = await response.json();
    return data.version;
  } catch (error) {
    console.error("Error fetching version:", error);
    return null;
  }
};
const getHeader = () => {
  const reqID = uuid();
  const token = getTokens();
  if (token)
    return {
      headers: {
        Authorization: token?.accessToken,
        reqMsgId: reqID,
      },
    };
};

export const getTokens = () => {
  const accessToken = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refreshToken");
  return {
    accessToken,
    refreshToken,
  };
};
let clientVersion: any = null;

// Fetch the client version once on app load
fetchClientVersion().then((version: any) => {
  clientVersion = version;
});

axiosRetry(instance, {
  retries: 2,
  retryCondition: (error: any) => {
    return error?.config["method"] == "get" ? true : false;
  },
});
instance.interceptors.response.use(
  (response: any) => {
    const clientversionvalue: string = clientVersion;
    const responseVersionvalue: string = response.headers
      ? response.headers["version"]
      : response.response && response.response.headers["version"];
    console.log(
      "clientversionvalue-",
      clientversionvalue,
      "server version value-",
      responseVersionvalue
    );
    if (compareVersions(responseVersionvalue, clientversionvalue) > 0) {
      window.localStorage.setItem("version-update-needed", "true");
    }
    return response;
  },
  (err) => {
    if (err?.response && err?.response?.status == 409) {
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }
    return Promise.reject(err);
  }
);
function compareVersions(version1: any, version2: any) {
  const v1 = version1.split(".").map(Number);
  const v2 = version2.split(".").map(Number);

  for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
    const num1 = v1[i] || 0;
    const num2 = v2[i] || 0;

    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }
  return 0;
}
export const uuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const getRequest = (url: string) => {
  return instance.get(`${url}`, getHeader());
};

const deleteRequest = (url: string, body?: object) => {
  return instance.delete(`${url}`, { ...getHeader(), data: body });
};
const postPostRequest = (url: string, body: object, method: string) => {
  if (method.toLowerCase() === "post")
    return instance.post(url, body, getHeader());
  if (method.toLowerCase() === "put")
    return instance.put(url, body, getHeader());
  if (method.toLowerCase() === "patch")
    return instance.patch(url, body, getHeader());
};

export const AxiosInstance = {
  getRequest: getRequest,
  postPostRequest: postPostRequest,
  deleteRequest: deleteRequest,
};
